import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { PRACTICE_SETTINGS_CONTROLLER } from "api/Service";

// Local-only override: force HealthLink on regardless of what the BE returns,
// so HL flows (vaccines, results, process messages) can be exercised locally
// even when the dev tenant has HealthLink disabled. Build-time flag — requires
// a dev-server restart to pick up. Never set in deployed environments.
const ENABLE_HL_LOCALLY = process.env.REACT_APP_ENABLE_HL_LOCALLY === "true";

export const usePracticeSettings = () => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["practiceSettings", tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}${PRACTICE_SETTINGS_CONTROLLER}`
      );
      const data = Array.isArray(response.data)
        ? response.data[0]
        : response.data;

      if (ENABLE_HL_LOCALLY) return { ...(data ?? {}), healthLink: true };

      return data || null;
    },
    enabled: !!tenantVal,
    staleTime: 5 * 60 * 1000,
  });
};
